import arrowIcon from "./../../../../assets/images/shaded-arrow.svg";
import DDxInputSelectorBg from "./../../../../assets/images/ddx-input-selector-bg.webp";
import bubble from "./../../../../assets/images/mic-bubble.svg";
import speakBox from "./../../../../assets/images/speak-box.svg";
import secureIcon from "./../../../../assets/images/secure.svg";
import agentBg from "./../../../../assets/images/agent-bg.svg";
import speak from "./../../../../assets/images/speak.svg";
import {
  JWT_TOKEN,
  LangSpecificMsg,
  LANGUAGE,
  languageOptions,
  MOBILE_NUMBER,
} from "../../../symptomCollector/utils/constants";
import { useEffect, useState } from "react";
import { ValidLanguages } from "../../../symptomCollector/utils/types";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import {
  getDecodedSCToken,
  interpolate,
} from "../../../symptomCollector/symptomCollectorHelper";
import {
  getLocalStorage,
  setLocalStorage,
} from "../../../../utils/localStorage";
import HeaderAppointment from "../headerAppointment/HeaderAppointment";
import { trackEvent } from "../../../../utils/helper";
import dayjs from "dayjs";
import { fetchAvatars, getReceptionistAgents } from "../../service";
import SelectLanguageDrawer from "./SelectLanguageDrawer";

export default function SelectLanguage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const { agentDetails, avatarImage, isBackButtonVisible } = state || {};

  const [selectedLanguage, setSelectedLanguage] = useState<string | null>(
    getLocalStorage(LANGUAGE) || null
  );
  const isSCLoggedIn = getLocalStorage(MOBILE_NUMBER);
  const LangSpecificMsgData =
    LangSpecificMsg[(selectedLanguage as ValidLanguages) || "english"];
  const phoneNumber = getLocalStorage(MOBILE_NUMBER);
  const [avatarImg, setAvatarImg] = useState<string | null>(null);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (avatarImage) {
      setAvatarImg(avatarImage);
    } else {
      getAvatarImage();
    }
  }, []);

  const getAvatarImage = async () => {
    const jwtToken = new URLSearchParams(searchParams).get(JWT_TOKEN) || "";
    const decodedToken: any = getDecodedSCToken(jwtToken);
    const receptionistAgentDetailsRes = await getReceptionistAgents(
      decodedToken?.user?.hm_id
    );
    const decodedTokenRes: any = getDecodedSCToken(receptionistAgentDetailsRes);
    if (decodedTokenRes?.user) {
      const res = await fetchAvatars();
      const avatar = res?.find(
        (item: any) => item?._id === decodedTokenRes?.user?.agent_id
      );
      setAvatarImg(avatar?.lookUrl);
    }
  };

  return (
    <div className="App symptom-collector relative min-h-screen">
      {/* Background Color */}
      <div
        className="fixed inset-0 h-full object-cover"
        style={{ background: "rgba(250, 248, 253, 1)" }}
      />

      <HeaderAppointment
        agentDetails={agentDetails}
        setSelectedLanguage={setSelectedLanguage}
        phoneNumber={phoneNumber}
        isBackButtonVisible={isBackButtonVisible === false ? false : true}
        isSCLoggedIn={isSCLoggedIn}
      />

      {/* Main Content */}
      <div className="relative z-10 p-[18px]">
        {selectedLanguage && (
          <div>
            <div className="recording-content">
              <div className="controls-container my-auto flex flex-col items-center gap-4">
                <>
                  <div
                    className="relative w-[120px] h-[120px] rounded-full"
                    style={{
                      background:
                        "linear-gradient(135deg, rgba(255, 255, 255, 0.9), rgba(240, 240, 255, 0.8))",
                      boxShadow: `
                        0px 0px 30px 10px rgba(250, 248, 253, 1),
                        0px 0px 60px 20px rgba(250, 248, 253, 1),
                        inset 0px -40px 60px -20px rgba(250, 248, 253, 1),
                        inset 0px 20px 40px -10px rgba(250, 248, 253, 1)
                      `,
                    }}
                  >
                    {/* Background image layer with gradient mask */}
                    <div
                      className="absolute inset-0 rounded-full overflow-hidden"
                      style={{
                        backgroundImage: `url(${agentBg})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        opacity: 0.85,
                        zIndex: 0,
                        maskImage:
                          "radial-gradient(circle at center, black 40%, transparent 100%)",
                        WebkitMaskImage:
                          "radial-gradient(circle at center, black 40%, transparent 100%)",
                      }}
                    ></div>

                    {/* Foreground content */}
                    <div className="relative z-10 w-full h-full flex items-center justify-center overflow-hidden rounded-full">
                      {avatarImg && (
                        <img
                          src={avatarImg}
                          alt="avatar"
                          style={{
                            position: "absolute",
                            top: "56%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: "90%",
                            borderRadius: "50%",
                            zIndex: 10,
                            maskImage:
                              "linear-gradient(to bottom, black 60%, transparent 100%)",
                            WebkitMaskImage:
                              "linear-gradient(to bottom, black 60%, transparent 100%)",
                          }}
                        />
                      )}
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <div
                      className="text-3xl font-bold"
                      style={{ fontFamily: "Playfair Display" }}
                    >
                      Hi,
                    </div>
                    <div
                      className="text-3xl font-bold"
                      style={{ fontFamily: "Playfair Display" }}
                    >
                      {interpolate(LangSpecificMsgData?.mira, {
                        name: agentDetails?.agent_name,
                      })}
                    </div>
                  </div>
                  <div className="text-[#454551] text-center text-sm">
                    {LangSpecificMsgData.aboutAppointment}
                  </div>

                  <div className="fixed bottom-14 left-1/2 transform -translate-x-1/2 w-full max-w-[450px] px-[18px] flex justify-between items-center gap-2">
                    <div
                      className="w-[70%] h-[52px] cursor-pointer relative"
                      style={{
                        background: `url(${DDxInputSelectorBg})`,
                        backgroundSize: "cover",
                        padding: "2px",
                        borderRadius: "12px",
                        flex: 1,
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/book-appointment`, {
                          state: {
                            selectedLanguage: selectedLanguage,
                            type: "chat",
                            agentDetails: agentDetails,
                            avatarImage: avatarImg,
                          },
                        });
                      }}
                    >
                      <div className="absolute inset-[2px] bg-white rounded-[10px] flex items-center justify-center">
                        <span className="w-full h-full px-4 bg-transparent text-center outline-none rounded-[10px] placeholder-gray-400 flex items-center text-[#98A2B3] text-sm">
                          {LangSpecificMsgData?.tapToBookAppointment}
                        </span>
                      </div>
                    </div>
                    <div
                      style={{
                        background:
                          "linear-gradient(180deg, #9A7DDA 0%, #2F2EA4 100%)",
                        borderRadius: "12px",
                        height: 52,
                      }}
                      className="flex items-center justify-center gap-2 cursor-pointer"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/book-appointment`, {
                          state: {
                            selectedLanguage: selectedLanguage,
                            type: "voice",
                            agentDetails: agentDetails,
                            avatarImage: avatarImg,
                          },
                        });
                      }}
                    >
                      <div className="relative p-[14px] rounded-[12px] h-[52px] backdrop-blur-[40%] flex items-center justify-center gap-2 cursor-pointer">
                        {/* Background image layer */}
                        <div
                          className="absolute inset-0 rounded-[12px] opacity-60"
                          style={{
                            backgroundImage: `url(${DDxInputSelectorBg})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            zIndex: 0,
                          }}
                        ></div>

                        {/* Foreground content */}
                        <div className="relative z-10 flex items-center justify-center gap-2">
                          <img
                            src={speak}
                            alt="speak"
                            className="w-[24px] h-[24px]"
                          />
                          <span className="text-sm text-white font-semibold">
                            Speak
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              </div>
            </div>
          </div>
        )}
      </div>
      {selectedLanguage && (
        <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 w-full max-w-[450px] px-[18px] flex justify-between items-center gap-2 m-auto mix-blend-luminosity">
          <div className="flex gap-2 justify-center opacity-40 m-auto">
            <img src={secureIcon} alt="secure-icon" />
            <div className="text-xs text-[#454551]">
              Your Data is Secured & only doctor can access it
            </div>
          </div>
        </div>
      )}

      {!selectedLanguage && (
        <SelectLanguageDrawer
          selectedLanguage={selectedLanguage}
          setSelectedLanguage={setSelectedLanguage}
        />
      )}
    </div>
  );
}